export function useBlankClick(func: () => void) {
  onMounted(() => {
    document.addEventListener('click', func)
  })

  onUnmounted(() => {
    document.removeEventListener('click', func)
  })
}
